import { FaPhoneAlt } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

function Navbar() {
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navRef = useRef(null);

  const menuData = [
    {
      title: { name: "Tutions", path: "/classroom" },
      links: [
        { name: "Class 1", path: "/tution/class1" },
        { name: "Class 2", path: "/tution/class2" },
        { name: "Class 3", path: "/tution/class3" },
        { name: "Class 4", path: "/tution/class4" },
        { name: "Class 5", path: "/tution/class5" },
        { name: "Class 6", path: "/tution/class6" },
        { name: "Class 7", path: "/tution/class7" },
        { name: "Class 8", path: "/tution/class8" },
        { name: "Class 9", path: "/tution/class9" },
      ],
    },
    {
      title: { name: "Stay and Study", path: "/hostel" },
      links: [
        { name: "Hostels", path: "/hostel" },
        { name: "Class 5", path: "/stay5" },
        { name: "Class 6", path: "/stay6" },
        { name: "Class 7", path: "/stay7" },
        { name: "Class 8", path: "/stay8" },
        { name: "Class 9", path: "/stay9" },
        { name: "Class 10", path: "/stay10" },
      ],
    },

    /* ❌ NO DROPDOWN */
    {
      title: { name: "Test Series", path: "/test-series" },
      noDropdown: true,
    },
    {
      title: { name: "Results", path: "/results" },
      noDropdown: true,
    },

    {
      title: { name: "Study Material", path: "/material" },
      links: [
        { name: "Notes", path: "/material/notes" },
        { name: "Previous Papers", path: "/material/papers" },
        { name: "DPPs", path: "/material/dpps" },
      ],
    },
    {
      title: { name: "More", path: "/about" },
      links: [
        { name: "About Us", path: "/about" },
        { name: "Contact Us", path: "/contact" },
        { name: "News", path: "/news" },
        { name: "FAQs", path: "/faqs" },
      ],
    },
  ];

  /* Close menu on outside click */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActiveMenu(null);
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="sticky-wrapper">
      <header className="navbar" ref={navRef}>
        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img src="/images/img2.png" alt="ACCESS" className="logo-img" />
          </Link>
        </div>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${mobileMenuOpen ? "open" : ""}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV LINKS */}
        <nav className={`nav-links ${mobileMenuOpen ? "open" : ""}`}>
          {menuData.map((menu, index) => (
            <div className="nav-item" key={index}>
              <div
                className="nav-title-wrapper"
                onClick={() => {
                  if (!menu.noDropdown) {
                    setActiveMenu(activeMenu === index ? null : index);
                  } else {
                    setActiveMenu(null);
                    setMobileMenuOpen(false);
                  }
                }}
              >
                <Link to={menu.title.path} className="nav-title">
                  {menu.title.name}
                </Link>

                {/* Arrow ONLY for dropdown menus */}
                {!menu.noDropdown && (
                  <span className={`arrow ${activeMenu === index ? "open" : ""}`}>
                    ▾
                  </span>
                )}
              </div>

              {/* Dropdown */}
              {!menu.noDropdown && activeMenu === index && (
                <div className="dropdown">
                  {menu.links.map((link, i) => (
                    <Link
                      key={i}
                      to={link.path}
                      onClick={() => {
                        setActiveMenu(null);
                        setMobileMenuOpen(false);
                      }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* CALL BUTTONS */}
        <a href="tel:+919964585585" className="call-link">
          <FaPhoneAlt />
        </a>

        <a href="tel:+919964585585" className="call-ring" aria-label="Call Us">
          <FaPhoneAlt />
        </a>

        {/* LOGIN */}
        {/* <div className="login-btn">
          <Link to="/login" className="btn">
            Login
          </Link>
        </div> */}

        {/* <div className="admin-btn">
          <Link to="/admin/login" className="btn admin">
            Admin Login
          </Link>
        </div> */}
        
      </header> 

      

      {/* OFFER BAR */}
      <div className="offer-bar">
        OFFER STARTED ON 12TH January -
        <p>Talk to our student advisor at </p> 9964585585
      </div>
    </div>
  );
}

export default Navbar;
